import { CommonFrontOfficeCrumbs } from './breadcrumb';

export const HistoricalCrumbs = [
  ...CommonFrontOfficeCrumbs,
  {
    name: 'Certificazione Storica',
    path: '/sportello/storiche',
  },
];
